import {ElementUtil} from './elementUtil.js';

export class MessageUtil {
	
	/**
	 * Displays a simple modal dialog Message
	 * 
	 * @param {html} message
	 * @param {function} okHandler
	 * @param {object} options
	 * @returns 
	 */
	showOkMessage(message, okHandler, options) {

		var dialog = document.createElement('vaadin-dialog');
		dialog.setAttribute('no-close-on-esc', '');
		dialog.setAttribute('no-close-on-outside-click', '');
		
		dialog.renderer = function (root, dialogBox) {
			// Check if there is a DOM generated with the previous renderer call to update its content instead of recreation
//		  if (root.firstElementChild) {
//			return;
//		  }
			var title;
			if (options && options.title) {
				title = ElementUtil.create({
					tag: 'div',
					'class': 'dialog-title',
					innerHTML: options.title
				});
			}

			const divMessage = window.document.createElement('div');
			divMessage.innerHTML = message;

			const br = window.document.createElement('br');

			const divButtons = window.document.createElement('div');
			divButtons.setAttribute('style', 'text-align: center; ');
			const okButton = window.document.createElement('vaadin-button');
			okButton.setAttribute('theme', 'primary');
			okButton.textContent = 'OK';
			
			okButton.addEventListener('click', function () {
				if (okHandler) {
					okHandler();
				}
				dialog.opened = false;
				dialog.remove();
			});
			divButtons.appendChild(okButton);

			if (title) {				
				root.append(title);
			}
			root.appendChild(divMessage);
			root.appendChild(br);
			root.appendChild(divButtons);			
		};
		document.body.append(dialog);

		dialog.opened = true;
	}	
	
	showConfirm(options) {
		
		var dialog = ElementUtil.create({
			tag: 'vaadin-dialog',
			'no-close-on-esc': true,
			'no-close-on-outside-click': true
		});
		dialog.renderer = function (root, dialogBox) {

			var title;
			if (options.title) {
				title = ElementUtil.create({
					tag: 'div',
					'class': 'dialog-title',
					innerHTML: options.title
				});
			}

			var content = ElementUtil.create({
				tag: 'div',
				innerHTML: options.message
			});

			var buttons = [];
			if (options.buttons) {
				options.buttons.forEach(function (buttonConfig) {
					buttons.push({
						style: 'margin-right: 5px;',
						innerHTML: buttonConfig.text,
						theme: buttonConfig.theme ? buttonConfig.theme : 'default',
						listeners: {
							click: function () {
								if (buttonConfig.handler) {
									buttonConfig.handler();
								}
								dialog.remove();
							}
						}
					});
				});
			}

			var buttonContainer = ElementUtil.create({
				tag: 'div',
				style: 'text-align: center;',
				defaults: {
					tag: 'vaadin-button'
				},
				children: buttons
			});

			var br = document.createElement('br');
			if (title) {				
				root.append(title);
			}
			root.append(
					content,
					br,
					buttonContainer
			);
		};
		
		document.body.append(dialog);
		dialog.opened = true;
	}	
	
	showToastError(message, title) {
		var MessageUtil = this;
		
		MessageUtil.showToast(title || '<i class="fas fa-exclamation-triangle fa-lg"></i> Error', message, {
			timeout: 7000,
			theme: 'error',
			position: 'bottom-end'
		});
	}
	
	/**
	 * Shows a soft notification
	 * 
	 * @param {html} title
	 * @param {html} message
	 * @param {object} options (timeout, theme(default, primary, contrast, success, error),
	 *  position(top-stretch, top-start, top-center, top-end, middled, bottom-*))
	 * @returns {undefined}
	 */
	showToast(title, message, options) {
		var defaultOptions = {
			timeout: 5000,
			theme: 'default',
			position: 'bottom-end'
		};
		
		options = Object.assign({}, defaultOptions, options) || defaultOptions;

		if (options.theme === 'default' && typeof title === 'string' && title.trim() === 'Success') {
			options.theme = 'success';
		}
		
		const notify = document.createElement('vaadin-notification');
		notify.setAttribute('theme', options.theme);
		
		notify.renderer = function (root) {
			const container = window.document.createElement('div');
			if (title) {
				const boldText = window.document.createElement('b');
				boldText.innerHTML = title;
				container.appendChild(boldText);

				const br = window.document.createElement('br');
				container.appendChild(br);
			}
			const messageContent = window.document.createElement('div');
			messageContent.innerHTML = message;			
			container.appendChild(messageContent);

			root.append(container);
		};

		document.body.append(notify);

		notify.position = options.position;
		notify.duration = options.timeout;
		notify.opened = true;

		notify.addEventListener('opened-changed', function () {
			notify.remove();
		});
		
	}
	
	/**
	 * Create a full page load mask with message; it will remove on close
	 * @param {html} message (default: Loading);
	 * @param {boolean} show (default: true)
	 * @param {text} theme
	 * @returns load mask element
	 */
	fullPageLoadMask(message, show, theme) {
		message = message || '<p><i class="fas fa-cog fa-spin fa-2x"></i> Loading...</p>';
		show = show || true;
				
		var loadMask = document.createElement('vaadin-dialog');
		loadMask.setAttribute('no-close-on-esc', '');
		loadMask.setAttribute('no-close-on-outside-click', '');
		
		var template = document.createElement('div');
		template.innerHTML = message;
		
		loadMask.renderer = function(root, dialogLocal) {
			root.append(template);
		};
		
		document.body.appendChild(loadMask);
		
		if (theme) {
			loadMask.setAttribute('theme', theme);
		}		 
		if (show) {
			loadMask.opened = true;
		}
		
		loadMask.remove = function() {
			loadMask.closed = true;
			document.body.removeChild(loadMask);			
		};
		
		loadMask.addEventListener('opened-changed', function () {
			if (!loadMask.closed) {
				document.body.removeChild(loadMask);
			}
		});
		return loadMask;
	}
	
	/**
	 * This will chop the text base on max
	 * @param {type} text
	 * @param {type} max
	 * @returns sub text with ... if it exceeds max
	 */
	ellipseText(text, max) {
		var choppedText = text;
		if (text && text.length > max) {
			choppedText = choppedText.subString(0, max-3) + '...';			
		}
		return choppedText;
	}

	/**
	 * Shows toast feedback for a small-set delete that may skip locked records.
	 * @param {object} result DeleteRecordsResultView from the API
	 */
	showDeleteRecordsResult(result) {
		var deleted = result.totalRecordsDeleted || 0;
		var skipped = result.totalRecordsSkippedDueToLock || 0;
		var message = result.message || ('Removed: ' + deleted);
		var theme = 'success';
		var title = 'Success';

		if (skipped > 0 && deleted === 0) {
			theme = 'error';
			title = 'Unable to Delete';
		} else if (skipped > 0) {
			theme = 'contrast';
			title = 'Partial Delete';
		}

		this.showToast(title, message, {
			theme: theme
		});
	}
	
}